import { Container, Paper, Typography, Button, Alert } from '@mui/material';
import React, { useState } from 'react';

import { apiFetch } from '../../lib/api';

import ShrinkTextField from '@/components/forms/ShrinkTextField';


const ForgotPassword: React.FC = () => {
  const [email, setEmail] = useState('');
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    try {
      await apiFetch('/auth/forgot-password', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });
      setSuccess(true);
    } catch (err: any) {
      setError(err.message || 'Failed to send reset email');
    }
  };

  return (
    <Container component="main" maxWidth="sm" sx={{ mt: 8 }}>
      <Paper sx={{ p: 3 }}>
        <Typography variant="h6" gutterBottom>Forgot Password</Typography>
        {success ? (
          <Alert severity="success">Password reset email sent</Alert>
        ) : (
          <form onSubmit={handleSubmit}>
            {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
            <ShrinkTextField
              fullWidth
              label="Email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              sx={{ mb: 2 }}
            />
            <Button type="submit" variant="contained">Send Reset Email</Button>
          </form>
        )}
      </Paper>
    </Container>
  );
};

export default ForgotPassword;
